import React, { useEffect, useState } from "react";
import { useAppDispatch } from "app/hooks";
import { Table, Loading } from "components";
import { ParkingTableHeadings } from "../ParkingTableHeadings/ParkingTableHeadings";
import { ParkingTableData } from "../ParkingTableData";
import { Parking } from "helpers";
import { ParkingEditModal } from "../ParkingEditModal";
import { useParkingManagementContext } from "pages/ParkingManagement/utils";
import { ParkingAddModal } from "../ParkingAddModal/ParkingAddModal";
import { useLocation } from "react-router-dom";

export const ParkingTable = () => {
  const dispatch = useAppDispatch();
  const isDev = process.env.NODE_ENV === "development";

  const { data, isSuccess, page, setPage, onPrefetchNext, onFetch } = useParkingManagementContext();
  const [error, setError] = useState<string>("");
  const [openEditModal, setOpenEditModal] = useState<boolean>(false);
  const [openAddModal, setOpenAddModal] = useState<boolean>(false);
  const [selectedParking, setSelectedParking] = useState<Parking | null>(null);
  const location = useLocation();
  const [notificationId, setNotificationId] = useState<number | null>(null);
  const [isRefetching, setIsRefetching] = useState(false);

  useEffect(() => {
    const state = location.state as {
      openModal?: boolean;
      notificationType?: string;
      notificationId?: number;
      fromNotification?: boolean;
    } | null;

    if (
      state?.fromNotification &&
      state.openModal &&
      (state.notificationType === "NEW_PARKING" || state.notificationType === "NEW_COMPANY")
    ) {
      setNotificationId(state.notificationId ?? null);
      onAdd(null);
    }
  }, [location.state]);

  const onFlag = (parking: Parking) => {
    console.log("Flagging company:", parking);
  };

  const onEdit = (parking: Parking) => {
    setSelectedParking(parking);
    setOpenEditModal(true);
  };

  const onAdd = (parking: Parking | null) => {
    setSelectedParking(parking || null);
    setOpenAddModal(true);
  };

  return (
    <>
      {isRefetching || isSuccess || !!data ? (
        <>
          <Table
            headings={<ParkingTableHeadings />}
            data={<ParkingTableData onFlag={onFlag} onEdit={onEdit} onAdd={onAdd} />}
            page={page}
            pageCount={data?.totalPages}
            onPageChange={({ selected }) => setPage(selected)}
            onMouseEnter={() => onPrefetchNext(page + 1)}
          />
          {openEditModal && selectedParking && (
            <ParkingEditModal
              open={true}
              setOpen={setOpenEditModal}
              parkingId={selectedParking.id.toString()}
              initialData={{
                parking_name_mk: selectedParking.translation.MK.name,
                parking_name_al: selectedParking.translation.AL.name,
                parking_name_en: selectedParking.translation.EN.name,
                longitude: selectedParking.coordinates.longitude.toString(),
                latitude: selectedParking.coordinates.latitude.toString(),
                municipality_id: selectedParking.municipality.id,
                area_type: selectedParking.area_type,
                total_parking_slots: selectedParking.total_parking_slots,
                payment_options: selectedParking.payment_options.map((p) => p.id),
                amenities: selectedParking.amenities.map((a) => a.id),
                address: selectedParking.address,
              }}
              onSuccess={async () => {
                setIsRefetching(true);
                await onFetch();
                setIsRefetching(false);
                setOpenAddModal(false);
              }}
            />
          )}
          {openAddModal && (
            <ParkingAddModal
              open={true}
              setOpen={setOpenAddModal}
              parkingId={notificationId?.toString() || selectedParking?.id.toString()}
              initialData={{
                parking_name_mk: selectedParking?.translation.MK.name || "",
                parking_name_al: selectedParking?.translation.AL.name || "",
                parking_name_en: selectedParking?.translation.EN.name || "",
                longitude: selectedParking?.coordinates.longitude.toString() || "",
                latitude: selectedParking?.coordinates.latitude.toString() || "",
                address: selectedParking?.address || "",
                municipality_id: selectedParking?.municipality.id || 0,
                area_type: selectedParking?.area_type || "",
                total_parking_slots: selectedParking?.total_parking_slots || 0,
                payment_options: selectedParking?.payment_options.map((p) => p.id) || [],
                amenities: selectedParking?.amenities.map((a) => a.id) || [],
              }}
              onSuccess={onFetch}
            />
          )}
        </>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default ParkingTable;
